const exhibitionChildrensLabel = ({
  childrenAges
}: {
  childrenAges: number[];
}): string => {
  const ages = childrenAges?.map(age => `${age}`).join(', ');
  let label = '';
  if (childrenAges?.length > 1) {
    label = childrenAges?.filter(age => age > 1)?.length > 0 ? `${ages} ` + "Anos" : `${ages} ` + "Ano";
  } else if (childrenAges?.length === 1) {
    label = childrenAges[0] > 1 ? `${ages} ` + "Anos" : `${ages} ` + "Ano";
  }
  return label != '' ? `(${label})` : label;
};
export default exhibitionChildrensLabel;